import EditIcon from '@mui/icons-material/Edit';
import Button from '@/trio-ui/Button';
import DropdownGroup from '@/trio-ui/DropdownGroup';
import Modal from '@/trio-ui/Modal';
import * as Styles from './UpdateCandidateStatus.styles';
import StatusTag from '../StatusTag';

type UpdateCandidateStatusComponentProps = {
  isUpdated: boolean;
  isOpen: boolean;
  isDisabled: boolean;
  currentStatus?: string;
  statuses: any[];
  onChangeStatus: (newStatus: string) => void;
  onSaveNewStatus: () => void;
  onToggleIsOpen: () => void;
};

export default function UpdateCandidateStatusComponent({
  isUpdated,
  isDisabled,
  isOpen,
  statuses,
  currentStatus,
  onChangeStatus,
  onSaveNewStatus,
  onToggleIsOpen,
}: UpdateCandidateStatusComponentProps): JSX.Element {
  const handleChange = (event: any): void => {
    const { value: newStatus } = event?.target;
    onChangeStatus(newStatus?.value ?? newStatus);
  };

  const Body = (
    <>
      <Styles.Text>Please, select the new status on the dropdown menu below.</Styles.Text>

      <Styles.DropdownBox>
        <DropdownGroup
          dropdownGroups={statuses || []}
          name="candidate-status-potions"
          defaultValue={currentStatus || undefined}
          label=""
          onChangeDropDown={handleChange}
        />
      </Styles.DropdownBox>
    </>
  );

  return (
    <>
      <Styles.Box>
        {isUpdated ? (
          <>
            <Styles.Label>Candidate Status updated to </Styles.Label>
            {currentStatus && <StatusTag outlined status={currentStatus} />}
          </>
        ) : (
          <Button
            disabled={isDisabled}
            onClick={onToggleIsOpen}
            variantStyle="filled"
            size="medium"
          >
            Update candidate Status
          </Button>
        )}
      </Styles.Box>

      <Modal
        modalId="update-candidate-status"
        isCentered
        size="sm"
        headerIcon={EditIcon}
        onConfirmClick={onSaveNewStatus}
        modalTitle="Updating Candidate Status"
        onConfirmLabel="Save"
        bodyRender={Body}
        onClose={onToggleIsOpen}
        isOpen={isOpen}
      />
    </>
  );
}
